export default {
  namespaced: true,
  installation_components: {
    next: "Seguindo",
    previous: "Anterior",
    no_options_found: "Nenhuma opção encontrada",
  },
};
